var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9,9.1l-9-9C9.7,0,9.3,0,9.1,0.1l-9,9C0,9.3,0,9.5,0,9.7C0.1,9.9,0.3,10,0.5,10H2v6.5C2,17.9,3.1,19,4.5,19h10 c1.4,0,2.5-1.1,2.5-2.5V10h1.5c0.2,0,0.4-0.1,0.5-0.3S19,9.3,18.9,9.1z M12,18H7v-5.5C7,11.7,7.7,11,8.5,11h2c0.8,0,1.5,0.7,1.5,1.5 V18z M16.5,9C16.2,9,16,9.2,16,9.5v7c0,0.8-0.7,1.5-1.5,1.5H13v-5.5c0-1.4-1.1-2.5-2.5-2.5h-2C7.1,10,6,11.1,6,12.5V18H4.5 C3.7,18,3,17.3,3,16.5v-7C3,9.2,2.8,9,2.5,9H1.7l7.8-7.8L17.3,9H16.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dd8ff64f.svg";
export { ForwardRef as ReactComponent };